<template>
  <div @keyup.enter="enterSearch">
    <el-form :model="form" ref="form" class="table-search-bar" inline>
      <el-form-item label="用户名" prop="userName">
        <el-input v-model="form.userName" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      ref="table"
      tooltip-effect="light"
      style="width: 100%"
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection">
      </el-table-column>
      <el-table-column
        prop="userName"
        label="用户名"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="注册手机"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="status"
        label="账号状态"
        :formatter="formatStatus">
      </el-table-column>
      <el-table-column
        prop="customerName"
        label="客户名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="corporateRepresentative"
        label="法人代表"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="detailAddress"
        label="客户所在地"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="状态"
        :formatter="statusFormatter"
        :show-overflow-tooltip="true">
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20 ,50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
    <el-checkbox v-model="checkAll" :indeterminate="indeterminate" @change="allCheck">全选</el-checkbox>
    <el-dropdown @command="handleCommand">
      <el-button type="primary">
        操作<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="lock" v-permission="'0030206'">账号锁定</el-dropdown-item>
        <el-dropdown-item command="unlock" v-permission="'0030206'">账号解锁</el-dropdown-item>
        <el-dropdown-item command="delete" v-permission="'0031101'">账号删除</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CustomerRegisterAccountManager',
  data () {
    return {
      form: {
        userName: '',
        mobile: ''
      },
      statusArr: [
        { value: '', label: '全部' },
        { value: 0, label: '正常' },
        { value: 1, label: '锁定' },
        { value: 3, label: '关闭' }
      ],
      checkAll: false,
      isIndeterminate: true,
      multipleSelection: '',
      id: ''
    }
  },
  computed: {
    ...mapGetters({
      list: 'getCustomerRegisterAccountManagerList',
      listState: 'getCustomerRegisterAccountManagerListState'
    }),
    indeterminate () {
      let checkedCount = this.multipleSelection.length
      return checkedCount > 0 && checkedCount < this.list.length
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getCustomerRegisterAccountManagerList', 'getCustomerRegisterAccountManagerDetail', 'lockCustomer', 'delCustomerRegisterAccountManager']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 全选
    allCheck () {
      this.$refs.table.toggleAllSelection()
    },
    // 下拉菜单
    handleCommand (val) {
      switch (val) {
        case 'lock':
          this.lock(1)
          break
        case 'unlock':
          this.lock(0)
          break
        case 'delete':
          this.lock(2)
          break
      }
    },
    // 批量锁定
    lock (status) {
      const params = {
        accounts: this.multipleSelection,
        status
      }
      const text = status === 1 ? '锁定后，该用户无法正常登陆！是否确认锁定？' : (status === 0 ? '解锁后，该用户可正常登陆！是否确认解锁？' : '是否确认删除选中客户？')
      const title = status === 1 ? '锁定' : (status === 0 ? '解锁' : '删除')
      if (this.multipleSelection.length) {
        this.$confirm(text, title, {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          await this.lockCustomer(params)
          this.handleSearch()
        }).catch(() => {})
      }
    },
    handleSizeChange (val) {
      this.getCustomerRegisterAccountManagerList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getCustomerRegisterAccountManagerList({ pageNo: val })
    },
    // 格式化状态
    formatStatus (row) {
      const status = this.$lodash.find(this.statusArr, { value: row.status }) || {}
      return status.label
    },
    // 表格选择
    handleSelectionChange (val) {
      this.multipleSelection = val.map(item => item.id)
      if (this.list.length > 0) {
        this.checkAll = this.multipleSelection.length === this.list.length
      }
    },
    handleSearch () {
      const params = {
        ...this.form,
        pageNo: 1
      }
      this.getCustomerRegisterAccountManagerList(params)
      this.checkAll = false
    },
    handleReset () {
      this.$refs['form'].resetFields()
      this.handleSearch()
    },
    statusFormatter (row) {
      const statusArr = ['待认证', '未通过', '通过', '未认证']
      return statusArr[row.authStatus]
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
